export default {
    name: 'footerSection',
    data() {
      return {
        subscribeFooter: true,
        messageStat: 0,
      };
    },
  }
  